class CartRecommendations extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('[data-variant-select]');
    this.button = this.querySelector('[data-quick-add]');

    if (!this.button) return;

    if (this.select) {
      this.select.addEventListener('change', () => {
        this.button.dataset.variantId = this.select.value;
      });
    }

    this.button.addEventListener('click', this.onQuickAdd.bind(this));
  }

  async onQuickAdd() {
    const variantId = this.button.dataset.variantId;
    const originalLabel = this.button.textContent;
    this.button.disabled = true;
    this.button.textContent = 'Adding…';

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });

      await this.refreshCartDrawer();
    } catch (error) {
      console.error('Quick add failed:', error);
      this.button.disabled = false;
      this.button.textContent = originalLabel;
    }
  }

  async refreshCartDrawer() {
    const response = await fetch(`${window.location.pathname}?sections=cart-drawer-section`);
    const data = await response.json();
    const html = data['cart-drawer-section'];

    if (!html) return;

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    // Only swap the content INSIDE the open <dialog>, never the dialog element
    // itself — replacing the dialog resets its open state and looks like the
    // drawer closed on you.
    const newInner = doc.querySelector('.cart-drawer__inner');
    const currentInner = document.querySelector('.cart-drawer__inner');

    if (newInner && currentInner) {
      currentInner.innerHTML = newInner.innerHTML;
    }

    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
  }
}

customElements.define('cart-recommendations', CartRecommendations);